import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

// Marks the pending-notifications counter as seen when the page becomes REALLY
// visible — not at render time: native tabs are preloaded in the background at app
// launch, and a render-time reset would clear the counter (and the tab bar badge)
// without the user having seen anything (see NotificationsController#index).
//
// The signal is native:appeared, emitted by the shell when the screen appears (iOS
// viewDidAppear, Android MainActivity.swapTab / WebFragment.onVisitRendered on the
// destination that is on screen).
//
// document.visibilityState is a fallback for iOS ONLY (trust-visibility value), where a
// cold visit can render — and connect this controller — after viewDidAppear has already
// fired. On Android it is not a visibility truth: every preloaded tab lives in the same
// activity window and reports "visible" even though its container is `gone`, so the
// counter was wiped at every launch.
export default class extends Controller {
  static values = { url: String, trustVisibility: Boolean }

  #seen = false

  // native:appeared vient de viewDidAppear : c'est LA vérité de visibilité — ne pas la
  // re-garder par document.visibilityState, que la WKWebView peut mettre à jour après.
  #markSeen = () => {
    if (this.#seen) return
    this.#seen = true
    post(this.urlValue).then(() => {
      window.dispatchEvent(new CustomEvent('tab-badge:refresh', { detail: { count: 0 } }))
    })
  }

  #markSeenIfVisible = () => {
    if (document.visibilityState === 'visible') this.#markSeen()
  }

  connect() {
    window.addEventListener('native:appeared', this.#markSeen)
    if (!this.trustVisibilityValue) return

    document.addEventListener('visibilitychange', this.#markSeenIfVisible)
    this.#markSeenIfVisible()
  }

  disconnect() {
    document.removeEventListener('visibilitychange', this.#markSeenIfVisible)
    window.removeEventListener('native:appeared', this.#markSeen)
  }
}
